import React, {
  useEffect,
  useState,
} from 'react';
import {
  TextField, Button, CardContent, CardHeader, FormControl, InputLabel, Select, MenuItem, Switch, FormControlLabel,
} from '@material-ui/core';
import GalleryField from 'components/GeneralCRUDComponent/FormFields/GalleryField/GalleryField';
import SearchFilterDropdown from 'components/SearchFilterComponent/SearchFilterDropdown';
import {
  WidgetInstance,
} from 'mobx-store/stores/customScreens/types';
import {
  Props,
  IconWidgetType,
} from './types';
import { NavigationOptions } from 'screens/addEditCustomScreen/components/navigationOptions';
import { ColorPalette } from 'screens/addEditCustomScreen/widgets/IconWidget/types';
import styles from './styles.module.scss';

const getWidgetParamsFields = (widgetType: IconWidgetType  | null, focusedWidgetData: WidgetInstance, handleChange: any) => {
  const actualWidgetType = focusedWidgetData.params.cardActionType || widgetType;
  if (actualWidgetType === IconWidgetType.EXTERNAL) {
    return (
      <TextField
        value={focusedWidgetData.params.cardActionExternalLink || ''}
        onChange={(event) => handleChange('cardActionExternalLink', event.target.value)}
        autoFocus
        margin="dense"
        id="cardActionExternalLink"
        label="Widget External Link"
        fullWidth
      />
    );
  }

  if (actualWidgetType === IconWidgetType.INTERNAL) {
    return (
      <>
        <NavigationOptions
          redirect={focusedWidgetData.params.cardActionRedirect}
          entityId={focusedWidgetData.params.cardActionEntityId}
          handleEntityIdChangeData={(value: string) => handleChange('cardActionRedirect', value)}
          handleRedirectChangeData={(value: string) => handleChange('cardActionEntityId', value)}
        />
        <TextField
          value={focusedWidgetData.params.cardActionParams || ''}
          onChange={(event) => handleChange('cardActionParams', event.target.value)}
          autoFocus
          margin="dense"
          id="cardActionParams"
          label="Widget Params"
          fullWidth
        />
      </>
    );
  }

  if (actualWidgetType === IconWidgetType.NATIVE) {
    return (
      <React.Fragment>
        <TextField
          value={focusedWidgetData.params.nativeModuleName || ''}
          onChange={(event) => handleChange('nativeModuleName', event.target.value)}
          autoFocus
          margin="dense"
          id="nativeModuleName"
          label="Native Module Name"
          fullWidth
        />
        <TextField
          value={focusedWidgetData.params.nativeModuleMethodName || ''}
          onChange={(event) => handleChange('nativeModuleMethodName', event.target.value)}
          autoFocus
          margin="dense"
          id="nativeModuleMethodName"
          label="Native Module Method Name"
          fullWidth
        />
      </React.Fragment>
    );
  }
};

const IconWidgetCard: React.FC<Props> = (props: Props) => {


	useEffect(() => {
		props.handleMultipleChangeData({
			textColor: props.focusedWidgetData.params.textColor || ColorPalette.primary,
			cardActionType: props.focusedWidgetData.params.cardActionType || IconWidgetType.INTERNAL
		})
	}, [props.focusedWidgetData.widgetInstanceId])
  return (
    (
      <>
        <CardContent>
          <TextField
            value={props.focusedWidgetData.params.title}
            onChange={(event) => props.handleChangeData('title', event.target.value)}
            autoFocus
            margin="dense"
            id="widgetTitle"
            label="Widget Title"
            fullWidth
          />
          {
            props.focusedWidgetData.params.textColor && 
            <FormControl variant="outlined" className={styles.colorsDropDown}>
              <InputLabel>Title Color</InputLabel>
              <Select
                label="Title Color"
                onChange={(event) => props.handleChangeData('textColor', `${event.target.value}`)}
                value={props.focusedWidgetData.params.textColor || ''}
              >
                {Object.values(ColorPalette).map((cp: string) => <MenuItem key={cp} value={cp}>{cp}</MenuItem>)}
              </Select>
            </FormControl>
          }

          <GalleryField
            errors=""
            touched=""
            filedType="GalleryField"
            onAddImage={(name, image) => {
              props.handleChangeData('imageURL', URL.createObjectURL(image));
            }}
            onRemoveImage={() => {
              props.handleChangeData('imageURL', '');
            }}
            name="widgetImage"
            value={props.focusedWidgetData.params.imageURL ? [{
              imageUrl: props.focusedWidgetData.params.imageURL,
            }] : []}
            accept="image/*"
            size={200}
            label="Widget Image"
            isLimitToOneImage
          />
          {            
            props.focusedWidgetData.params.cardActionType && 
            <SearchFilterDropdown
            label="Widget Type"
            searchFilterDropdown={{
              filters: Object.entries(IconWidgetType).map((type) => ({
                value: type[1], name: type[0],
              })),
              value: props.focusedWidgetData.params.cardActionType ,
              // initialValue: IconWidgetType.EXTERNAL,
              onChange: (status: IconWidgetType) => {
                props.handleChangeData('cardActionType', status);
              },
            }}
          />
          }
          <FormControlLabel
            control={
              <Switch
                checked={String(props.focusedWidgetData.params.isButton) === 'true'}
                onChange={(event) => props.handleChangeData('isButton', `${event.target.checked}`)}
                name="footer button"
                color="primary"
              />
            }
            label="footer button"
          />
          {
            String(props.focusedWidgetData.params.isButton) === 'true' &&
            <TextField
              value={props.focusedWidgetData.params.buttonText}
              onChange={(event) => props.handleChangeData('buttonText', event.target.value)}
              autoFocus
              margin="dense"
              id="buttonText"
              label="button text"
              fullWidth
            />
          }
          {
            getWidgetParamsFields(props.focusedWidgetData.params.cardActionType as IconWidgetType, props.focusedWidgetData, props.handleChangeData)
          }
        </CardContent>
      </>
    )
  );
};

export default IconWidgetCard;
